import { isTestEnvironment } from './utils';
export function openUrl(url) {
    window.open(url, isTestEnvironment() ? '_self' : '_blank');
}
export function isExternalUrl(linkUrl, currentUrl) {
    const { hostname: linkHostname, protocol: linkProtocol } = new URL(linkUrl);
    const { hostname: currentHostname, protocol: currentProtocol } = new URL(currentUrl);
    // Consider the link to be 'external' even if just the protocol changes, as this could be a change from
    // secure to insecure, and should result in showing an external link warning:
    return (linkHostname.toLowerCase() !== currentHostname.toLowerCase() ||
        linkProtocol.toLowerCase() !== currentProtocol.toLowerCase());
}
